module.exports = __webpack_public_path__ + "img/intent_8.d79aab16.png";